export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo-projection/src/noop.js
// module id = Ko/M
// module chunks = 0